
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------


const _logging_ChangeLogControllerHelper = new Map<string, Object>();


export const logging_ChangeLogControllerHelper = _logging_ChangeLogControllerHelper;

